import { useState } from 'react';
import type { ReactNode } from 'react';

import AccessibilityContext from './AccessibilityContext';

export interface IAccessibility {
  storytellerEnabled: boolean;
  setStorytellerEnabled?: (val: boolean) => void;
  isCursorBig?: boolean;
  setIsCursorBig?: (val: boolean) => void;
  isHightlightLink?: boolean;
  setIsHightlightLink?: (val: boolean) => void;
  isDislexic?: boolean;
  setIsDislexic?: (val: boolean) => void;
  fontSize?: number;
  setFontSize?: (val: number) => void;
  languaje?: string;
  setLanguaje?: (val: string) => void;
  langTeller?: string;
  setLangTeller?: (val: string) => void;
  isReadingGuideEnabled?: boolean;
  setIsReadingGuideEnabled?: (val: boolean) => void;
}

type Props = {
  children: ReactNode | undefined;
  value: IAccessibility;
};

const AccessibilityProvider = ({ children, value }: Props) => {
  const [storytellerEnabled, setStorytellerEnabled] = useState(value.storytellerEnabled);
  const [isCursorBig, setIsCursorBig] = useState(value.isCursorBig);
  const [isHightlightLink, setIsHightlightLink] = useState(value.isCursorBig);
  const [isDislexic, setIsDislexic] = useState(value.isDislexic);
  const [fontSize, setFontSize] = useState(value.fontSize);
  const [languaje, setLanguaje] = useState(value.languaje);
  const [langTeller, setLangTeller] = useState(value.langTeller);
  const [isReadingGuideEnabled, setIsReadingGuideEnabled] = useState(value.isReadingGuideEnabled);

  const contextValue = {
    ...value,
    storytellerEnabled,
    setStorytellerEnabled,
    isCursorBig,
    setIsCursorBig,
    isHightlightLink,
    setIsHightlightLink,
    isDislexic,
    setIsDislexic,
    fontSize,
    setFontSize,
    languaje,
    setLanguaje,
    langTeller,
    setLangTeller,
    isReadingGuideEnabled,
    setIsReadingGuideEnabled,
  };
  return (
    <AccessibilityContext.Provider value={contextValue}>{children}</AccessibilityContext.Provider>
  );
};

export default AccessibilityProvider;
